import styled from 'styled-components';

export const InputStyled = styled.input`
  display: block;
  background-color: #F6F8FC;
  border: 1px solid #e8e9ed;
  margin-bottom: 20px;
  width: 100%;
  border-radius: 10px;
  padding: 10px;
`;

export const Label = styled.label`
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
`;